<template>
    <div class="container-fluid">
        <div class="row mt-3">
        <div class="col-6 col-sm-6 col-md-6">
        <form @submit.prevent="submit" >
            <div class="form-group" v-if="errors.length" >
                <ul class="list-group">
                    <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
                </ul>
            </div>
            <div class="form-group input-group-sm">
                <label >Jednostka organizacyjna</label>
                <select class="form-control" v-model="form.storeId">
                    <option v-for="option in storesOptions" :key="option.id" v-bind:value="option.id">
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="form-group input-group-sm">
                <label >Data raportu</label>
                <datepicker 
                        class="mt-1 "
                        v-model="form.createDate"
                        :monday-first="true"
                        :language="lang"
                    ></datepicker>
            </div>
            <div class="form-group input-group-sm">
                <label >AKCESORIA - Łączna sprzedaż akcesoriów</label>
                <input class="form-control" type="number" min="0" step="any" v-model="form.accessoriesPrice"/>
            </div>
            <div class="form-group input-group-sm">
                <label >SERWIS - Łączna sprzedaż usług serwisowych</label>
                <input class="form-control" type="number" min="0" step="any" v-model="form.servicePhonesPrice"/>
            </div>
            <div class="form-group input-group-sm">
                <label >DOŁADOWANIA - Łącznie sprzedaż doładowań</label>
                <input class="form-control" type="number" min="0" step="any" v-model="form.topUpsPrice"/>
            </div>
            <div class="form-group input-group-sm">
                <label >TERMINAL - Łączna wartość płatności kartą</label>
                <input class="form-control" type="number" min="0" step="any" v-model="form.terminalPrice"/>
            </div>
            <div class="form-group input-group-sm">
                <label >UTARGI - Stan gotówki w kopercie na koniec dnia</label>
                <input class="form-control" type="number" min="0" step="any" v-model="form.revenuePrice"/>
            </div>
            <div class="form-group input-group-sm">
                <label >TELEFONY - Stan gotówki w kopercie na koniec dnia</label>
                <input class="form-control" type="number" min="0" step="any" v-model="form.phonesPrice"/>
            </div>
            <div class="form-group input-group-sm">
                <label >UTARGI NADWYŻKA - Stan gotówki w kopercie rzeczy sprzedane, a nie zdjęte ze stanu</label>
                <input class="form-control" type="number" min="0" step="any" v-model="form.cashInEnvelope"/>
            </div>
            
            <input class="btn btn-success torre-btn btn-sm mr-2" type="submit" value="Zapisz">
            <router-link class="btn btn-secondary btn-sm" :to="{ name: 'reports' }">Anuluj</router-link>
        </form>
        </div>
        </div>
    </div>
</template>
<script>
import {pl} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import alertify from 'alertifyjs'
import ReportsService from "@/components/reports/ReportsService"

const reportsService = new ReportsService()


export default {
    components: {
      datepicker 
    },
    name: "ReportsNew",
    data: function () {
        return {
            errors: [],
            lang: pl,
            storesOptions: [],
            form: {
                storeId: -1,
                createDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                accessoriesPrice: "",
                servicePhonesPrice: "",
                topUpsPrice: "",
                revenuePrice: "",
                phonesPrice: "",
                terminalPrice: "",
                cashInEnvelope: ""
            }
        }
    },
    created() {
        this.initStoresOptions()
    },
    methods: {
        submit() {
            this.clearErrors()
            reportsService.addReport(this.form, this.onAddSuccess, this.onAddError)
        },
        onAddSuccess(data) {
            this.$router.push({name: 'reports'})
            alertify.set('notifier','position', 'top-center');
            alertify.success("Raport został zapisany").delay(3);
        },
        onAddError(err) {
            console.log(err)
            this.errors = err
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można dodać raportu.").delay(3);
        },
        initStoresOptions() {
            reportsService.initStores(this.onStoresSuccess)
        },
        onStoresSuccess(data, selectedStoreId) {
            this.storesOptions = data
            this.form.storeId = selectedStoreId
        },
        clearErrors() {
            this.errors = []
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/reports/ReportsNew.vue